<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/references
</style>

<template>
    <Zone
        :id="$json.references.id"
        :dataLabel="$json.references.dataLabel"
        :contrast="contrast"
        class="g_ref"
        autoHeight>
        <Heading
            :level="2"
            v-html="$json.references.title"/>
        <ul class="g_row">
            <li v-for="(item, index) of $json.references.list" :key="index">
                <div
                    class="g_logo"
                    v-img-src="{ folder: 'logos', name: item.image, suffix: false }" />
                <Paragraph
                    :content="item.title"
                    size="XL"
                    class="g_visually_hidden" />
            </li>
        </ul>
        <Cta
            v-if="!pageIs('references')"
            type="text"
            class="g_link"
            :link="$json.references.all.link"
            target="_self"
            fontIcon="fn_arrow"
            :content="$json.references.all.cta" />
        <Paragraph
            :content="$json.references.subtitle"
            size="XL" />
        <Contact v-if="pageIs('references')" />
    </Zone>
</template>

<script>
import Contact from '../../components/Contact'

export default {
    name: 'References',
    components: {
        Contact
    },
    props: {
        contrast: {
            type: String,
            default: 'dark'
        }
    },
    methods: {
        pageIs (page) {
            return this.$landing.project === page
        }
    }
}
</script>
